module.exports = __webpack_public_path__ + "media/components/terrain-mapping/icons/Renewable energy generation-ada2c23e112f2003bdcd490a8ece5983.png";